import Vue from 'vue'
import { BulmaToast } from '@/components/BulmaToast'

export default {
  install() {
    Vue.prototype.$notification = Vue.notification = this
  },

  success(title, message) {
    BulmaToast.open({
      message: message,
      type: 'is-success',
      position: 'is-top',
      queue: false
    })
  },

  error(title, message) {
    BulmaToast.open({
      message: message,
      type: 'is-danger',
      position: 'is-top',
      queue: false
    })
  },

  warning(title, message) {
    BulmaToast.open({
      message: message,
      type: 'is-warning',
      position: 'is-top',
      queue: false
    })
  },

  validationError(_title, message) {
    let errMessage = 'Validation errors. Please fix before saving'

    if (message && message !== '') {
      errMessage = message
    }
    BulmaToast.open({
      message: errMessage,
      type: 'is-danger',
      position: 'is-top',
      queue: false
    })
  },

  openNotificationWithType(type, title, message, duration) {
    BulmaToast.open({
      message: message,
      type: `is-${type}`,
      position: 'is-top',
      queue: false,
      duration: duration || 3000
    })
  },

  // Every read is guarded: a rejected request can arrive with no response at all, or with an
  // HTML block page where JSON was expected. This runs inside the caller's catch, so a throw
  // here means no toast at all.
  openMessageXhrError(title, xhrRequest) {
    const request = xhrRequest?.response?.request
    // A response the browser refused to expose reports status 0, which reads as "Error 0:".
    const status = request?.status || xhrRequest?.response?.status || ''
    var message

    if (request?.response) {
      try {
        const xhrResponse = JSON.parse(request.response)
        message = xhrResponse.message
        if (xhrResponse.modelState) {
          Object.keys(xhrResponse.modelState).forEach(function(key) {
            message += ` ${xhrResponse.modelState[key]}`
          })
        }
      } catch (e) {
        // Not JSON, so something in front of the API answered.
        message = request.statusText || xhrRequest?.message
      }
    } else {
      message = request?.statusText || xhrRequest?.message
    }

    if (!message) {
      message = 'The request could not be completed.'
    }

    BulmaToast.open({
      message: status ? `Error ${status}: ${message}` : message,
      type: 'is-danger',
      position: 'is-top',
      queue: false
    })
  }
}
